import { Content } from "./Time.stlyed";

export const Time = (props) => {
  const { input, className, label, disabled } = props;

  return (
    <Content className={className}>
      <label>{label}</label>
      <input type="time" disabled={disabled} step="30" placeholder="00:00:00" {...input} />
    </Content>
  );
};
